import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import React from "react";
import Collections from "./sdd/sections/Collections";
import CollectionsDetail from "./sdd/sections/CollectionsDetail";

const PageSddCollections = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'sdd.collections' });

    return (
            <Routes>
                <Route path="/" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <Collections/>
                    </>
                }/>
                <Route path="/:id" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <CollectionsDetail/>
                    </>
                }/>
            </Routes>
    );
}

export default PageSddCollections;